import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Box, Image, SectionHelper, Text } from '@wix/design-system';
import { InfoCircle } from '@wix/wix-ui-icons-common';
import { AppContextProvider } from '../../AppLoader';
import downloadAppQrCode from '../../../assets/images/downloadAppQrCode.png';
import s from '../PremiumUsers2FaEnforcement/modals.scss';

/**
 * Body of the redesigned "Download the Wix app (QR)" step — the QR + the 1/2/3 list
 * (+ the no-devices error banner). Card chrome is provided by `WixAppWizardRedesign`.
 */
export const DownloadAppQrBody: React.FC = observer(() => {
  const {
    rootStore: {
      postLoginStore: {
        premiumUsers2FaEnforcementStore: { ownerAppStore: store },
      },
    },
  } = useContext(AppContextProvider);
  const { t } = useTranslation();

  return (
    <Box direction="vertical" width="100%" gap={3}>
      {store.showNoDevicesError && (
        <SectionHelper
          skin="danger"
          size="small"
          showCloseButton
          showPrefixIcon
          prefixIcon={<InfoCircle size={18} />}
          onClose={() => (store.showNoDevicesError = false)}
        >
          {t(
            'wixAppEnforcement.addOwnerApp.wizard.download.qrcode.no-devices-error',
          )}
        </SectionHelper>
      )}
      <Box align="center" width="100%">
        <Image
          src={downloadAppQrCode}
          transparent
          width={129}
          height={133}
          borderRadius="0"
        />
      </Box>
      <Text weight="thin" className={s.steps}>
        <ol style={{ margin: 0 }}>
          <li style={{ marginBottom: '12px', marginInlineStart: 18 }}>
            {t('wixAppEnforcement.addOwnerApp.wizard.download.qrcode.steps.1')}
          </li>
          <li style={{ marginBottom: '12px', marginInlineStart: 18 }}>
            {t('wixAppEnforcement.addOwnerApp.wizard.download.qrcode.steps.2')}
          </li>
          <li style={{ marginBottom: 0, marginInlineStart: 18 }}>
            {t('wixAppEnforcement.addOwnerApp.wizard.download.qrcode.steps.3')}
          </li>
        </ol>
      </Text>
    </Box>
  );
});
